import { vialLabels } from "./vialLabels";

export default function VialPhoto({ product }) {
  if(product.photo_url) return <div className="vial-thumbnail custom-product-photo"><img src={product.photo_url} alt={product.name} loading="lazy" decoding="async"/></div>;
  if(product.category === "Etiquetas") return <div className="label-thumbnail" role="img" aria-label={`Etiqueta ${product.name}`}><small>ETIQUETA</small><b>{product.name}</b></div>;
  const lines = vialLabels(product.name);
  return <div className="vial-thumbnail"><div className="vial-photo" role="img" aria-label={`Ampola ${product.name}`}>
    <img src={`${process.env.PUBLIC_URL || ""}/vials/aurevy-base.webp`} alt="" loading="lazy" decoding="async" width="1024" height="1536" />
    <div className={`vial-label ${lines.length > 1 ? "vial-blend" : ""}`} aria-hidden="true">
      {lines.map((line, index) => <div className="vial-label-line" key={index}>
        <b style={{ fontSize: `${Math.max(9, Math.min(lines.length > 1 ? 10 : 14, 185 / Math.max(line.name.length, 1)))}px` }}>{line.name}</b>
        {line.amount && <strong>{line.amount}</strong>}
      </div>)}
    </div>
  </div></div>;
}